// extracted by mini-css-extract-plugin
module.exports = {"container":"Main-layout_container__UCCuR"};